export default __webpack_public_path__ + "static/media/building.541f489f.svg";